<template>
  <v-app>
    <div
      class="back"
      style="position: fixed; height: 100vh; width: 100vw;"
    >
      <div
        style="position: absolute; top: 0; right: 0; padding: 15px; text-align: right;"
      >
        <span style="font-size: 12px; color: white; "> {{ version }}</span>
      </div>
      <v-container class="fill-height">
        <v-container
          :class="dialog ? 'mb-16' : ($vuetify.breakpoint.xs ? 'mb-auto' : 'mb-auto mt-10')"
          :style="($vuetify.breakpoint.xs ? 'padding: 4px;' : 'width: 400px;')"
        >
          <v-container>
            <v-row
              class="layout-logos-login fill-height px-4 height"
              align="center"
              justify="center"
            >
              <v-img
                src="@/assets/logo_branca.png"
                height="200px"
                contain
              />
            </v-row>
          </v-container>
          <div
            v-if="!loader"
          >
            <v-form
              id="form_login"
              ref="form_login"
              v-model="valid"
              @submit.prevent="postLogin"
            >
              <div>
                <div
                  style="color: #E8EBF4; margin-bottom: 5px; margin-left: 5px;"
                  :class="!$vuetify.breakpoint.xs ? 'mt-8' : 'mt-0'"
                >
                  Usuário
                </div>
                <v-text-field
                  v-model="userEntrada"
                  :rules="loginRules"
                  background-color="secund"
                  hide-details
                  solo
                  label="Email ou CPF/CNPJ"
                  name="userEntrada"
                  prepend-inner-icon="mdi-account"
                  validate-on-blur
                  style="margin-bottom: 18px;"
                />
                <div style="color: #E8EBF4; margin-bottom: 5px; margin-left: 5px">
                  Senha
                </div>
                <v-text-field
                  v-model="password"
                  background-color="secund"
                  hide-details
                  solo
                  prepend-inner-icon="mdi-key"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required]"
                  :type="show2 ? 'text' : 'password'"
                  name="password"
                  label="Senha"
                  @click:append="show2 = !show2"
                />
                <div
                  style="text-align: end; margin-bottom: 28px;"
                >
                  <v-btn
                    x-small
                    text
                    class="text-none"
                    @click="esqueciSenha"
                  >
                    <span
                      style="font-size: 12px; color: #E8EBF4; margin-top: 13px;"
                    >Esqueci minha senha</span>
                  </v-btn>
                </div>
                <v-row
                  justify="center"
                >
                  <v-btn
                    type="submit"
                    width="250"
                    class="text-none"
                    color="secondary"

                    style="margin-top: 26px; border-radius: 8px; color: #40607C;"
                  >
                    <span style="font-weight: 600">Acessar</span>
                  </v-btn>
                </v-row>
              </div>
            </v-form>
          </div>
          <v-container v-else>
            <v-row
              style="height: 229px"
              justify="center"
              align="center"
            >
              <v-progress-circular
                :size="100"
                :width="8"
                color="secondary"
                dark
                :indeterminate="true"
              />
            </v-row>
          </v-container>
        </v-container>

        <v-snackbar
          v-model="snackbar"
          top
          right
          :timeout="4000"
          color="error"
          transition="slide-x-reverse-transition"
        >
          <v-row
            justify="space-between"
          >
            <div class="d-flex align-center">
              <v-icon class="mx-2">
                mdi-alert-circle-outline
              </v-icon>
              <span style="font-size: 14px; font-weight: 500">{{ message }}</span>
            </div>
            <v-btn
              small
              icon
              dark
              text
              @click="snackbar = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-snackbar>
      </v-container>
    </div>
    <v-banner
      v-if="showBanner"
      style="position: absolute; bottom: 0; z-index: 2;"
      two-line
      class="ma-4"
      elevation="11"
      color="white"
      shaped
      width="98%"
      transition="slide-y-transition"
    >
      O Manager Clínicas utiliza cookies para melhorar a experiência do usuário. Por favor veja nossa <a
        href="https://app.managerclinicas.com.br/termos/politica_privacidade.html"
        target="_blank"
        color="primary"
      > <span
        style="color: #000509; font-weight: 700;"
      >política de privacidade</span></a> para maiores informações. Ao clicar em "Aceitar Cookies" ou continuar a utilizar o site, você concorda com o uso de Cookies.

      <template v-slot:actions="{ dismiss }">
        <v-btn
          class="text-none"
          color="primary"
          rounded
          variant="outlined"
          dark
          @click="recusarCookies(dismiss)"
        >
          Recusar Cookies
        </v-btn>

        <v-btn
          class="text-none ms-4 text-white"
          color="primary"
          rounded
          dark
          @click="aceitarCookies(dismiss)"
        >
          Aceitar Cookies
        </v-btn>
      </template>
    </v-banner>
    <img
      style="max-height: 160px; max-width: 160px;position: fixed; bottom: 10px; right: 10px; z-index: 1;"
      src="@/assets/esteio/powered_by_horizontal_b.png"
      contain
    >
  </v-app>
</template>
<script>
  import { login } from '@/services/AuthService'
  import { validarCNPJ, validarCPF } from '../../utils/validacoes'
  import email from 'vuelidate/lib/validators/email'
  import rules from '../../utils/formRules'
  import packageJson from '../../../package.json'

  export default {
    props: ['cadastro'],
    data () {
      return {
        showBanner: true,
        dialog: false,
        advertising: true,
        performance: true,
        userEntrada: null, //
        password: null,
        email: null,
        formEnv: null,
        cpf: null,
        cnpj: null,
        user: null,
        snackbar: false,
        message: '',
        loader: false,
        valid: null,
        show1: false,
        show2: false,
        rules,
        loginRules: [
          (v) => {
            return (
              validarCPF(this.userEntrada) || validarCNPJ(this.userEntrada) || email(this.userEntrada)
            ) || 'Favor inserir um email, CPF ou CNPJ válido'
          },
          rules.required,
        ],
        version: this.getVersion(),
      }
    },
    created () {
      if (this.cadastro && this.cadastro === 'cadastro') {
        this.dialog = true
      }
    },
    mounted () {
      if (localStorage.getItem('aceitaCookies') === 'true') {
        this.showBanner = false
      }
    },
    methods: {
      esqueciSenha () {
        this.$router.push('/ForgotPassword')
      },
      aceitarCookies (dismiss) {
        localStorage.setItem('aceitaCookies', true)
        dismiss()
        this.showBanner = false
      },
      recusarCookies () {
        localStorage.removeItem('aceitaCookies')
        dismiss()
        this.showBanner = false
      },
      postLogin () {
        if (this.$refs.form_login.validate()) {
          this.loader = true
          this.api.login(this.userEntrada, this.password).then(response => {
            login(response.user, response.access_token)
            return this.api.listEntidade('permission', { params: { list: true } })
          }).then(response => {
            this.$store.commit('SET_PERMISSIONS', response)
          }).catch(_err => {
            this.message = _err.message
            this.snackbar = true
            this.loader = false
          })
        }
      },
      getVersion () {
        const versionApi = localStorage.getItem('version_api')
        return 'versão: ' + (
          versionApi
            ? (versionApi + (process.env.NODE_ENV !== 'production' ? '(dev)' : '') + (packageJson.version !== versionApi
              ? '*' : ''))
            : packageJson.version + (process.env.NODE_ENV !== 'production' ? '(dev)' : '') + '*'
        )
      },
      closeDialog () {
        this.dialog = false
      },
    },
  }
</script>
<style lang="css" scoped>

.v-card {
  border-radius: 20px;
}

.back {
  background-color: #173148;
  /* background-image: url('../../assets/loginimage.png'); */
  background-size: cover;
}

.layout-logos-login {
    align-items: center!important;
}

.gradient-line-right {
  height: 2px;
  width: 100px;
  background: linear-gradient(270deg,rgba(182, 182, 182, 1) 0%, rgba(217, 217, 217, 0) 94.39%);
  display: inline-block;
}

.gradient-line-left {
  height: 2px;
  width: 100px;
  background: linear-gradient(270deg, rgba(217, 217, 217, 0) 0%,rgba(182, 182, 182, 1) 94.39%);
  display: inline-block;
}

.v-input{
    border-radius: 8px;
}

</style>
